<template>
  <div class="confirmation-modal">
    <div class="confirmation-modal-wrapper">
    
      <div class="modal-header-wrapper">
        <div class="left-wrapper">
          <ion-icon :name="titleIcon[0]"/>
          <ion-icon class="minor-icon" v-if="titleIcon.length > 1" :name="titleIcon[1]"></ion-icon>
          <div class="header-title">
            {{ title }}
          </div>
        </div>
  
        <div class="right-wrapper" @click="closeModal" v-if="canClose">
          <ion-icon name="close"></ion-icon>
        </div>
      </div>
  
      <slot class="content-modal-wrapper"/>
         
      <div class="button-wrapper" :style="{'justify-content': (confirmButtonText && !cancelButtonText) || (cancelButtonText && !confirmButtonText) ? 'center' : 'space-between'}">
        <button v-if="cancelButtonText" class="modal-cancel-button" @click="closeModal">
          {{ cancelButtonText }}
        </button>
    
        <button v-if="confirmButtonText" class="modal-confirm-button" @click="methodHandler">
          {{ confirmButtonText }}
        </button>
      </div>
    </div>
    <div class="opacity-background" />
  </div>
 
</template>

<script>
export default {
  name: 'confirmationModal',
  data() {
    return {

    }
  },
  methods: {
    closeModal() { 
      const doc = document.getElementsByClassName('background-pause')[0];
      if(doc) {
        doc.style.zIndex = '4';
      }
      this.$emit('close-modal', false)
    }
  },
  props: {
    title: {
      type: String
    },
    titleIcon: '',
    contentIcon: {
      type: String
    },
    cancelButtonText: {
      type: String,
    },
    confirmButtonText: {
      type: String
    },
    methodHandler: {
      type: Function
    },
    canClose: {
      type: Boolean
    }
  },
  beforeMount() {
    
  }
}
</script>

<style scoped lang="scss">

.confirmation-modal {
  .confirmation-modal-wrapper {
    position: fixed;
    border-radius: 16px;
    border: 2px solid var(--border);
    background: var(--leftMenuColor);
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.25);
    width: 532px;
    min-height: 206px;
    display: inline-flex;
    padding: 20px 16px;
    flex-direction: column;
    align-items: center;
    gap: 26px;
    z-index: 4;
    top: 50%;
    left: 50%;
    z-index: 6;
    transform: translate(-50%, -50%);
    .modal-header-wrapper {
      border-bottom: 1px solid var(--border);
      color: var(--text);
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      align-self: stretch;
      padding: 0;

      ion-icon {
        width: 23px;
        height: 23px;
      }

      .left-wrapper {
        display: flex;
        gap: 8px;
        position: relative;
        align-items: center;

        .header-title {
          font-weight: 500;
          font-size: 18px;
        }

        .minor-icon {
					height: 14px;
					width: 13px;
					position: absolute;
					left: 13px;
					top: 4px;
					z-index: 10;
				}
      }

      .right-wrapper {
        ion-icon {
          cursor: pointer;
        }
      }
    }

    .button-wrapper {
      display: flex;
      justify-content: space-between;
      width: 100%;

      .modal-cancel-button {
        display: flex;
        padding: 8px 32px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 20px;
        border: 1px solid #7F8897;
        font-weight: 600;
        background: var(--leftMenuColor);
        color: var(--text);
      }
      .modal-confirm-button {
        display: flex;
        padding: 8px 32px;
        align-items: flex-start;
        gap: 10px;
        border-radius: 20px;
        font-weight: 600;
        border: 1px solid var(--darkBlue);
        background: var(--darkBlue);
        color: #fff
      }
    }
  }
  @media (max-width: 500px) {
    .confirmation-modal-wrapper {
      position: fixed;
      border-radius: 16px;
      border: 2px solid var(--border);
      background: var(--leftMenuColor);
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.25);
      width: auto;
      min-height: 206px;
      display: inline-flex;
      padding: 20px 16px;
      flex-direction: column;
      align-items: center;
      gap: 26px;
      z-index: 4;
      top: 10%;
      left: 20%;
      z-index: 6;
      transform: none;
    }
  }
  .opacity-background {
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    overflow: hidden;
    position: fixed;
    z-index: 3;
    background: var(--opacityBackground);
  }
  span {
    color: var(--text)
  }
}
  
</style>



// WEBPACK FOOTER //
// src/vue/views/components/confirmationModal.vue